module.exports = __webpack_public_path__ + "static/media/bg.adede886.png";